import {types} from '../../types';

const setGetJackpotHistoryListAction = (payload) => {
    return {
        type: types.jackpot.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetJackpotHistoryListAction as SetGetJackpotHistoryListAction
}
